/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { Subject } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ButtonComponent, ButtonStyle, FormActionsComponent, ModalComponent, PropertiesTableComponent,
    PropertiesTableRowComponent, SpinnerComponent } from "typedb-cloud-framework";
import { Cluster, ClusterPrice } from "../../../concept/cluster";
import { ClusterApi } from "../../../service/cluster/cluster-api.service";
import { ApplicationState } from "../../../service/application-state.service";
import { renderThousandthCentsAsUSD } from "../../../util";

export type PauseResumeModalData = { cluster: Cluster, action: "resume" | "pause" };

@Component({
    selector: "tp-pause-resume-modal",
    templateUrl: "./pause-resume-modal.component.html",
    styleUrls: ["./pause-resume-modal.component.scss"],
    imports: [FormsModule, ModalComponent, FormActionsComponent, AsyncPipe, SpinnerComponent]
})
export class PauseResumeModalComponent {
    @Output() confirmed = new EventEmitter<void>();
    isSubmitting$ = new Subject<boolean>();
    price$ = this.clusterApi.getClusterPriceThousandthCentsPerHour({ cluster: this.data.cluster, teamUuid: this.app.requireCurrentTeam().uuid });
    submitText = this.data.action == "resume" ? "Resume cluster" : "Pause cluster";
    title = this.data.action == "resume" ? "Resume cluster" : "Pause cluster";
    buttonIdPrefix = `${this.data.action}Modal`
    submitButtonStyle: ButtonStyle = this.data.action == "resume" ? "primary-outline green stroke" : "primary-outline red stroke";

    constructor(
        private dialogRef: MatDialogRef<PauseResumeModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PauseResumeModalData,
        private clusterApi: ClusterApi, private app: ApplicationState
    ) {}

    confirm(): void {
        this.isSubmitting$.next(true);
        this.confirmed.emit();
    }

    close(): void {
        this.dialogRef.close();
    }

    runningPriceString(price: ClusterPrice) {
        return `${renderThousandthCentsAsUSD(price.running.thousandthCentsPerHour)}/hour`;
    }

    pausedPriceString(price: ClusterPrice) {
        return `${renderThousandthCentsAsUSD(price.paused.thousandthCentsPerHour, 3)}/hour`;
    }
}
